import React from 'react';
import {Row, Col, Button} from 'antd';
import {marginBottom, marginLeft, marginTop} from "../../common/script";


export default class AboutUsPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            itemList: [{
                icon: 'images/ic_locked.png',
                title: 'Data Management',
                img: 'https://qiniu.mrcargo.com/limo_web_warehouse_1.png'
            }, {
                icon: 'images/ic_money.png',
                title: 'Management of Statements',
                img: 'https://qiniu.mrcargo.com/limo_web_warehouse_2.png'
            }, {
                icon: 'images/ic_package.png',
                title: 'Cargo Tracing',
                img: 'https://qiniu.mrcargo.com/limo_web_warehouse_3.png'
            }, {
                icon: 'images/ic_wood.png',
                title: 'Location Management',
                img: 'https://qiniu.mrcargo.com/limo_web_warehouse_4.png'
            }, {
                icon: 'images/ic_scan.png',
                title: 'Code-Scan Management',
                img: 'https://qiniu.mrcargo.com/limo_web_warehouse_5.png'
            }, {
                icon: 'images/ic_material.png',
                title: 'Material Management',
                img: 'https://qiniu.mrcargo.com/limo_web_warehouse_6.png'
            }],

        }
    }


    render() {
        return (<div>
                <div style={{position: 'relative'}} className={'flex-row width100p'}>
                    <img src={'https://qiniu.mrcargo.com/zs-warehouse-banner.png'} alt={'zs-warehouse-banner'}
                         className={'width100p'}/>
                    <div className={'width100p first-context font-size64 text-center'} style={marginTop(10)}>
                        <span className={'colorfff'}>E-WMS</span>
                    </div>
                </div>
                <Row justify={'center'} className={'bg-f5f7fa'}>
                    <Col span={12} style={Object.assign(marginTop(8), marginBottom(8))}>
                        <div >
                            <span className={'quotes-view'}>"</span>
                            <span className={'font-size18 color0D182B'} style={marginTop(2)}> Starting with new oversea
                                marketing development, including everything from compliance to raw material and factory
                                sourcing, logistics, and more, we offer end-to-end service for our client in the goods
                                supply chain.
                            </span>
                            <span className={'quotes-view'}>"</span>
                        </div>
                    </Col>
                </Row>
                <Row style={marginTop(12)}>
                    <Col span={16} offset={4}>
                        {
                            this.itemTitleView('Function & Feature')
                        }
                        <div style={marginTop(2)} className={'color666666 font-size24'}>
                            Continuous, Follow-up, Functional Innovation
                        </div>
                        <Row gutter={[24, 24]} style={marginTop(6)}>
                            {
                                this.state.itemList.map((item, index) => {
                                    return this.itemView(item, index)
                                })
                            }
                        </Row>
                    </Col>
                </Row>
                <div style={Object.assign({position: 'relative'}, marginTop(12))} className={'flex-row width100p'}>
                    <img src={'https://qiniu.mrcargo.com/zs-warehouse-bg-oper.png'} alt={'zs-warehouse-bg-oper'}
                         className={'width100p'}/>
                    <Row className={'width100p first-context'}>
                        <Col span={16} offset={4} style={Object.assign(marginTop(8), marginBottom(12))}>
                            {
                                this.itemTitleView('Operating Procedures')
                            }
                            <div style={marginTop(8)} className={'flex-row justify-center'}>
                                <img src={'https://qiniu.mrcargo.com/zs-warehouse-oper.png'}
                                     alt={'zs-warehouse-oper'}/>
                            </div>
                        </Col>
                    </Row>
                </div>
                <div style={{position: 'relative'}} className={'flex-row width100p'}>
                    <img src={' https://qiniu.mrcargo.com/zs-warehouse-bg-bottom.png'} alt={'zs-warehouse-bg-bottom'}
                         width={'100%'}/>
                    <div className={'width100p  first-context'}>
                        <div style={Object.assign(marginLeft(40), marginTop(2))}>
                            <div className={'font-size40 colorfff font-weight400'} style={marginTop(6)}>
                                <div>Contact us quickly</div>
                                <div>to get the fastest and best service</div>
                            </div>
                            <Button type="primary" shape="default" size={'large'}
                                    className={'concat-btn'}
                                    style={marginTop(5)} onClick={() => {
                                this.props.navigationRoute('/concatUs')
                            }
                            }>Need to contact </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    /**
     * 内容标题布局
     * @param title 标题
     */
    itemTitleView(title) {
        return <div className={'flex-row'} style={{alignItems: 'flex-end'}}>
            <div className={'font-size64 color1E170B'}>{title}</div>
        </div>
    }


    itemView(item, index) {
        return <Col key={index} span={8}>
            <div className={'bg-grep-gradient'} style={{padding: '16px'}}>
                <div className={'flex-row-normal justify-between'}>
                    <img src={item.icon} alt={item.icon}/>
                    <div className={'font-bold'} style={itemIndexTxtView}>{index + 1}</div>
                </div>
                <div className={'font-size24 colorfff font-bold'}>{item.title}</div>
            </div>
        </Col>
    }

}

const itemIndexTxtView = {
    fontSize: '88px',
    opacity: 0.1,
    color: '#fff',
    marginTop: '-28px',
}



